import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { AppApi } from '@wix/wix-data-client-common'
import {
  addPattern,
  runTransactionWithRetry,
  UNDO_REDO_LABELS,
} from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { getPageRouteData } from '../../../worker/utils/getPageRouteData'

export const updateDynamicPagePrefix = async ({
  editorSdkProxy,
  appApi,
  pageRef,
  prefix,
}: {
  editorSdkProxy: EditorSDK
  appApi: AppApi
  pageRef: PageRef
  prefix: string
}) => {
  const { routerData, routerRef, pattern, definition } = await getPageRouteData(
    {
      editorSdkProxy,
      pageRef,
    },
  )

  const newPrefix = prefix.toLowerCase()

  if (routerData.prefix === newPrefix) {
    return
  }

  if (routerData.pages.length > 1) {
    throw new Error('Not implemented for routers with multiple routes')
  }

  await runTransactionWithRetry(editorSdkProxy, async () => {
    const newRouterRef = await editorSdkProxy.routers.add({
      prefix: newPrefix,
      config: addPattern({ patterns: {} }, pattern, definition),
    })

    await editorSdkProxy.routers.pages.move({
      pageRef,
      fromRouterRef: routerRef,
      toRouterRef: newRouterRef,
    })

    await editorSdkProxy.routers.remove({ routerRef })
  })

  await editorSdkProxy.history.add({
    label: UNDO_REDO_LABELS.UPDATE_ROUTERS,
    params: { pageRefs: [pageRef] },
  })

  await appApi.handleChangedRouters({ pageRefs: [pageRef] })
}
